import { Link } from "react-router-dom";
import { RESERVATION_POLICY } from "../lib/constants";

const THEMES = {
  dark: { box: "border-[#B76E79]/40 bg-[#B76E79]/10", title: "text-[#E8B4B8]", body: "text-white/85" },
  light: { box: "border-[#0a0a0a]/15 bg-[#0a0a0a]/[0.04]", title: "text-[#B76E79]", body: "text-[#0a0a0a]/80" },
};

export const ReservationPolicy = ({ theme = "dark", className = "", testid = "reservation-policy" }) => {
  const t = THEMES[theme];
  return (
    <div className={`rounded-2xl border p-4 md:p-5 ${t.box} ${className}`} data-testid={testid}>
      <div className={`text-[10px] tracking-[0.22em] uppercase font-semibold ${t.title}`}>{RESERVATION_POLICY.title}</div>
      <div className={`mt-2 space-y-2 text-[12.5px] leading-relaxed ${t.body}`}>
        {RESERVATION_POLICY.paragraphs.map((p) => <p key={p}>{p}</p>)}
      </div>
    </div>
  );
};

export const ReservationPolicyShort = () => (
  <p className="text-[11px] text-white/55 leading-relaxed max-w-3xl" data-testid="footer-reservation-policy">
    <span className="text-[#E8B4B8] font-semibold">{RESERVATION_POLICY.title}:</span> {RESERVATION_POLICY.short}{" "}
    <Link to="/terms#late-arrival" className="underline underline-offset-4 hover:text-[#E8B4B8]" data-testid="footer-policy-link">Read the full policy</Link>
  </p>
);
